import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Avatar, Button, Col, Input, Popover, Row, Tooltip } from 'antd';
import {
    AppstoreOutlined, DeleteOutlined, EditOutlined, HomeOutlined, InfoCircleOutlined, LoginOutlined, MenuOutlined, PhoneOutlined, SearchOutlined,
    UserAddOutlined
} from '@ant-design/icons';
import styles from './style.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken, getCurrentUser } from '../../utils/authHelpers';
import { setIsSignIn } from '../../features/Auth/authSlice';
import JobSeekerSubscription from '../CommonElements/JobSeekerSubscription';
import PricingComponent from '../../pages/GuestUsers/PricingComponent';
import { setSelectedMenu } from '../../features/UserInfo/UserSlice';
import HeaderRightSection from './HeaderRightSection';
import { onSetDefaultData } from '../../features/Global/globalSlice';
import HeaderDrwaer from './HeaderDrwaer';
import { setChangesStatus } from '../../features/Organization/OrganizationInfo/OrganizationInfoSlice'
import { get_jobseeker } from '../../features/UserInfo/userInfoSlice';

const TopNavbar = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = getAuthToken()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const currentUser = getCurrentUser();
    const loggedInToken = getAuthToken();
    const { userProfile } = useSelector((state) => state.global);
    const [issubscription, setIsSubscription] = useState(false)
    const [issubscriptionJob, setIsSubscriptionJob] = useState(false);
    const { selectedMenu } = useSelector((state) => state.userData);
    const [subscription, setSubscription] = useState(userProfile?.subscription);
    const [isPricing, setIsPricing] = useState(false)
    const location = useLocation();

    const renderGuestItems = useMemo(() => ([
        {
            label: "Home", key: "/", goToPage: () => {
                navigate("/")
                dispatch(setSelectedMenu('/'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Find Job", key: "/jobseeker", goToPage: () => {
                navigate("/jobseeker")
                dispatch(setSelectedMenu('/jobseeker'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Request Demo", key: "/request-demo", goToPage: () => {
                navigate("/request-demo")
                dispatch(setSelectedMenu('/request-demo'))
                dispatch(onSetDefaultData())
            }
        },
        {
            key: "/pricing",
            label: "Pricing",
            goToPage: () => {
                setIsPricing(true)
            }
        }

        ,

        {
            label: "About Us", key: "/about-us", goToPage: () => {
                navigate("/about-us")
                dispatch(setSelectedMenu('/about-us'))
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Contact Us", key: "/contact-us", goToPage: () => {
                navigate("/contact-us")
                dispatch(setSelectedMenu("/contact-us"))
                dispatch(onSetDefaultData())
            }
        },
    ]), [navigate]);

    const jobSeekerMenuItems = useMemo(() => ([
        {
            label: "Dashboard", key: "/jobseeker/dashboard", goToPage: () => {
                navigate("/jobseeker/dashboard")
                dispatch(onSetDefaultData())
            }
        },
        // {
        //     label: "Tickets", key: "/jobseeker/tickets", goToPage: () => {
        //         navigate("/jobseeker/tickets")
        //         dispatch(onSetDefaultData())
        //     }
        // },
        {
            label: "Recommended Jobs", key: "/jobseeker/recommended-jobs", goToPage: () => {
                navigate("/jobseeker/recommended-jobs")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Saved Jobs", key: "/jobseeker/save-jobs", goToPage: () => {
                navigate("/jobseeker/save-jobs")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "References", key: "/jobseeker/reference-people", goToPage: () => {
                navigate("/jobseeker/reference-people")
                dispatch(onSetDefaultData())
            }
        },
        {
            label: "Calender", key: "/jobseeker/calender", goToPage: () => {
                navigate("/jobseeker/calender")
                dispatch(onSetDefaultData())
            }
        },
    ]), [navigate]);

    const orgMenuItems = useMemo(() => ([
        {
            label: "Dashboard", key: "/dashboard", goToPage: () => {
                navigate("/dashboard")
                dispatch(onSetDefaultData());
                dispatch(setChangesStatus('open'))
            }
        },
        {
            label: "Job Status", key: "/job-status", goToPage: () => {
                navigate("/job-status")
                dispatch(onSetDefaultData())
                dispatch(setChangesStatus('open'))
            }
        },
        // {
        //     label: "Recommend Candidate", key: "/recommend-candidate", goToPage: () => {
        //         navigate("/recommend-candidate")
        //         dispatch(onSetDefaultData())
        //         dispatch(setChangesStatus('open'))
        //     }
        // },
        // { label: "Analytics", key: "/analytics", goToPage: () => navigate("/analytics") },
        {
            label: "Calender", key: "/organization-calender", goToPage: () => {
                navigate("/organization-calender")
                dispatch(onSetDefaultData())
                dispatch(setChangesStatus('open'))
            }
        },
    ]), [navigate]);

    const navItems = loggedInToken
        ? (currentUser === 'organization' ? orgMenuItems : jobSeekerMenuItems)
        : renderGuestItems;

    useEffect(() => {
        if (isPricing) {
            dispatch(setSelectedMenu("/pricing"));
        } else {
            dispatch(setSelectedMenu(location.pathname));
        }
    }, [isPricing, location.pathname]);


    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navIcons = {
        "/": <HomeOutlined />,
        "/jobseeker": <SearchOutlined />,
        "/request-demo": <AppstoreOutlined />,
        "/pricing": <UserAddOutlined />,
        "/about-us": <InfoCircleOutlined />,
        "/contact-us": <PhoneOutlined />,
        "/login": <LoginOutlined />,
        "/sign-up": <UserAddOutlined />,
    };

    useEffect(() => {
        if (showMobileMenu && windowWidth > 1064) {
            setShowMobileMenu(false);
        }
    }, [windowWidth, showMobileMenu]);

    const hasRun = useRef(false);

    useEffect(() => {
        if (currentUser === 'employee') {
            dispatch(get_jobseeker(navigate))
        }
    }, [])


    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.topNav}>
                    <div className={styles.leftSection}>
                        {windowWidth <= 1064 && (
                            <div className={styles.mobileMenuIcon} onClick={() => setShowMobileMenu(!showMobileMenu)}>
                                <MenuOutlined className='text-black add-cursor' />
                            </div>
                        )}
                        {windowWidth >= 1064 && (
                            <div className={styles.logo} onClick={() => {
                                navigate('/')
                                dispatch(setSelectedMenu("/"))
                            }}>
                                <img
                                    src={"https://eployrs-config-file.s3.ap-south-1.amazonaws.com/eployrs/Images/logo/LOGO_ICON_BLACK_V01.jpg"}
                                    alt="Logo"
                                    width={40}
                                    height={40}
                                    className={styles.logoStyle}
                                    loading="eager"
                                    decoding="async"
                                    draggable={false}
                                />
                            </div>
                        )}

                        {windowWidth > 1064 && (
                            <div className={styles.navLinks}>
                                {navItems.map((item) => (
                                    <a
                                        key={item.key}
                                        className={selectedMenu === item.key ? ` ${styles.activeMenues}` : `text-black btnfonts ${styles.inactivemenues}`}
                                        onClick={item.goToPage}
                                    >
                                        {item.label}
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className={styles.desktopMenu}>
                        {loggedInToken ? (
                            <div>
                                <HeaderRightSection />
                            </div>
                        ) : (
                            <>
                                <Button
                                    onClick={() => {
                                        navigate('/login');
                                        dispatch(setIsSignIn(true));
                                    }}
                                    shape="round"
                                    type="text"
                                    className={`btnfonts darkGradiant text-white ${styles.loginBtn}`}
                                >
                                    Log in
                                </Button>
                                <Button
                                    onClick={() => {
                                        navigate('/sign-up');
                                        dispatch(setIsSignIn(false));
                                    }}
                                    shape="round"
                                    type="primary"
                                    className={`btnfonts darkGradiant text-white ${styles.signupBtn}`}
                                >
                                    Sign up
                                </Button>
                            </>
                        )}
                    </div>
                </div>
                <HeaderDrwaer setShowMobileMenu={setShowMobileMenu} showMobileMenu={showMobileMenu}
                    navItems={navItems} navIcons={navIcons} />

                {/* <SubscriptionSection subscription={subscription} issubscription={issubscription} setIsSubscription={setIsSubscription}
                    setSubscription={setSubscription} />
                <PricingComponent visible={issubscriptionJob} onClose={() => setIsSubscriptionJob(false)} />
                <PricingComponent visible={isPricing} onClose={() => setIsPricing(false)} /> */}
                <PricingComponent
                    visible={
                        token
                            ? (currentUser === 'organization'
                                ? issubscription
                                : issubscriptionJob)
                            : isPricing
                    }
                    onClose={() => {
                        if (!token) return setIsPricing(false);
                        if (currentUser === 'organization') return setIsSubscription(false);
                        return setIsSubscriptionJob(false);
                    }}
                />

            </div>
        </>
    );
};

export default TopNavbar;